import { render, staticRenderFns } from "./HojaCargaForm.vue?vue&type=template&id=2fb68170"
import script from "./HojaCargaForm.vue?vue&type=script&lang=js"
export * from "./HojaCargaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports